/* Bewertungssystem: Zeichenzähler, Absenden per App-Proxy, Meldeweg (barrierefrei, BFSG) */
(function () {
  /* Zeichenzähler für die Textareas mit data-char-count */
  document.querySelectorAll('textarea[data-char-count]').forEach(function (ta) {
    var out = ta.parentElement.querySelector('[data-char-count-output]');
    if (!out) return;
    var max = ta.getAttribute('maxlength') || 2000;
    var min = ta.getAttribute('minlength') || 30;
    var update = function () {
      out.textContent = ta.value.length + ' / ' + max + ' Zeichen (mind. ' + min + ')';
    };
    ta.addEventListener('input', update);
    update();
  });

  /* Bewertung absenden: JSON-POST an die App-Proxy-Route der Reviews-App.
     Shopify hängt Signatur + logged_in_customer_id serverseitig an; die App
     prüft Kauf + Inhalt automatisch und antwortet mit {ok, message|error}. */
  document.querySelectorAll('form[data-review-ajax]').forEach(function (form) {
    var endpoint = form.getAttribute('data-endpoint');
    var productId = form.getAttribute('data-product-id');
    var fields = form.querySelector('[data-review-fields]');
    var successBox = form.querySelector('[data-review-success]');
    var successText = form.querySelector('[data-review-success-text]');
    var errorBox = form.querySelector('[data-review-error]');
    var submitBtn = form.querySelector('[type="submit"]');
    var showNameEl = form.querySelector('[data-show-name]');
    var nameField = form.querySelector('[data-name-field]');
    var nameInput = form.querySelector('[data-name-input]');

    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.hidden = false;
      errorBox.scrollIntoView({ block: 'center' });
    }

    /* Namensfeld nur einblenden + required, wenn der Kunde seinen Namen zeigen will
       (Default: aus -> Bewertung erscheint „Ohne Namen"). */
    function syncNameField() {
      var show = !!(showNameEl && showNameEl.checked);
      if (nameField) nameField.hidden = !show;
      if (nameInput) {
        if (show) nameInput.setAttribute('required', 'required');
        else nameInput.removeAttribute('required');
      }
    }
    if (showNameEl) {
      showNameEl.addEventListener('change', function () {
        syncNameField();
        if (showNameEl.checked && nameInput) nameInput.focus();
      });
      syncNameField();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorBox) {
        errorBox.hidden = true;
        errorBox.textContent = '';
      }

      var ratingEl = form.querySelector('input[name="rating"]:checked');
      var titleEl = form.querySelector('[name="title"]');
      var bodyEl = form.querySelector('[name="body"]');
      var nameEl = form.querySelector('[name="displayName"]');
      var consentEl = form.querySelector('[name="consent"]');

      if (!productId) { showError('Dieses Produkt kann derzeit nicht bewertet werden.'); return; }
      if (!ratingEl) { showError('Bitte wähle eine Sternebewertung (1–5).'); return; }
      var title = ((titleEl && titleEl.value) || '').trim();
      var body = ((bodyEl && bodyEl.value) || '').trim();
      var displayName = ((nameEl && nameEl.value) || '').trim();
      if (title.length < 1) { showError('Bitte gib eine Überschrift ein.'); return; }
      if (body.length < 30) { showError('Dein Text muss mindestens 30 Zeichen lang sein.'); return; }
      if (body.length > 2000) { showError('Dein Text darf höchstens 2000 Zeichen lang sein.'); return; }
      if (consentEl && !consentEl.checked) { showError('Bitte bestätige die Einwilligung zur Veröffentlichung.'); return; }
      var showName = !!(showNameEl && showNameEl.checked);
      if (showName && displayName.length < 1) {
        showError('Bitte gib deinen Anzeigenamen ein – oder entferne das Häkchen, um ohne Namen zu veröffentlichen.');
        return;
      }

      var payload = {
        productId: productId,
        rating: Number(ratingEl.value),
        title: title,
        body: body,
        displayName: showName ? displayName : '',
        showName: showName,
      };

      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) {
            return { status: r.status, data: d };
          });
        })
        .then(function (res) {
          if (res.data && res.data.ok) {
            if (fields) fields.hidden = true;
            if (successText && res.data.message) successText.textContent = res.data.message;
            if (successBox) {
              successBox.hidden = false;
              successBox.scrollIntoView({ block: 'center' });
              if (successBox.focus) successBox.focus({ preventScroll: true });
            }
          } else {
            showError((res.data && res.data.error) || 'Das hat leider nicht geklappt. Bitte versuche es später erneut.');
          }
        })
        .catch(function () {
          showError('Verbindung fehlgeschlagen. Bitte versuche es später erneut oder sende uns deine Bewertung über das Kontaktformular.');
        })
        .then(function () {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        });
    });
  });

  /* Meldung absenden: JSON-POST an die App-Proxy-Route /apps/reviews/report.
     Öffentlich (jeder darf melden, Art. 16 DSA); der Betreiber wird per E-Mail
     informiert. */
  document.querySelectorAll('form[data-report-ajax]').forEach(function (form) {
    var endpoint = form.getAttribute('data-endpoint');
    var fields = form.querySelector('[data-report-fields]');
    var successBox = form.querySelector('[data-report-success]');
    var successText = form.querySelector('[data-report-success-text]');
    var errorBox = form.querySelector('[data-report-error]');
    var submitBtn = form.querySelector('[type="submit"]');
    var select = form.querySelector('[data-report-select]');

    function showError(msg) {
      if (!errorBox) return;
      errorBox.textContent = msg;
      errorBox.hidden = false;
      errorBox.scrollIntoView({ block: 'center' });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }

      var reviewId = select ? select.value : '';
      var label = select && select.selectedIndex >= 0 ? select.options[select.selectedIndex].text : '';
      var emailEl = form.querySelector('[name="email"]');
      var reasonEl = form.querySelector('[name="reason"]');
      var goodFaithEl = form.querySelector('[name="goodFaith"]');
      var email = ((emailEl && emailEl.value) || '').trim();
      var reason = ((reasonEl && reasonEl.value) || '').trim();

      if (!reviewId) { showError('Bitte wähle die betroffene Bewertung aus.'); return; }
      if (!email) { showError('Bitte gib deine E-Mail-Adresse an.'); return; }
      if (reason.length < 10) { showError('Bitte gib einen Meldegrund an (mindestens 10 Zeichen).'); return; }
      if (goodFaithEl && !goodFaithEl.checked) { showError('Bitte bestätige, dass deine Angaben nach bestem Wissen richtig sind.'); return; }

      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ reviewId: reviewId, reviewLabel: label, email: email, reason: reason, goodFaith: goodFaithEl ? goodFaithEl.checked : true }),
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, data: d }; });
        })
        .then(function (res) {
          if (res.data && res.data.ok) {
            if (fields) fields.hidden = true;
            if (successText && res.data.message) successText.textContent = res.data.message;
            if (successBox) {
              successBox.hidden = false;
              successBox.scrollIntoView({ block: 'center' });
              if (successBox.focus) successBox.focus({ preventScroll: true });
            }
          } else {
            showError((res.data && res.data.error) || 'Das hat leider nicht geklappt. Bitte versuche es später erneut.');
          }
        })
        .catch(function () {
          showError('Verbindung fehlgeschlagen. Bitte versuche es später erneut.');
        })
        .then(function () {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        });
    });
  });

  /* Meldeweg: Klick auf „Bewertung melden" öffnet das Melde-Formular und wählt
     die betroffene Bewertung vor. */
  var reportBox = document.getElementById('bewertung-melden');
  var reportSelect = reportBox ? reportBox.querySelector('[data-report-select]') : null;
  document.querySelectorAll('[data-report-target]').forEach(function (link) {
    link.addEventListener('click', function () {
      if (reportBox && 'open' in reportBox) reportBox.open = true;
      if (reportSelect) {
        var handle = link.getAttribute('data-report-target');
        for (var i = 0; i < reportSelect.options.length; i++) {
          if (reportSelect.options[i].value === handle) { reportSelect.selectedIndex = i; break; }
        }
      }
    });
  });
})();

/* ============================================================
   Bewertungen: clientseitige Sortierung + Sterne-Filter (v7)
   Rein zusätzlich — greift NICHT in Absenden/Melden ein.
   Hooks: [data-reviews-list], .reviews__item[data-rating][data-date],
          [data-review-sort], .reviews__chip[data-star],
          [data-reviews-status], [data-reviews-empty]
   ============================================================ */
(function () {
  var list = document.querySelector('[data-reviews-list]');
  if (!list) return;
  var items = Array.prototype.slice.call(list.querySelectorAll('.reviews__item'));
  if (!items.length) return;
  var sortSel = document.querySelector('[data-review-sort]');
  var chips = Array.prototype.slice.call(document.querySelectorAll('.reviews__chip'));
  var empty = document.querySelector('[data-reviews-empty]');
  var status = document.querySelector('[data-reviews-status]');
  var star = 0;

  function apply() {
    var s = sortSel ? sortSel.value : 'neu';
    var arr = items.slice();
    arr.sort(function (a, b) {
      var ra = parseFloat(a.dataset.rating) || 0, rb = parseFloat(b.dataset.rating) || 0;
      var da = a.dataset.date || '', db = b.dataset.date || '';
      if (s === 'hoch') return rb - ra || (da > db ? -1 : (da < db ? 1 : 0));
      if (s === 'niedrig') return ra - rb || (da > db ? -1 : (da < db ? 1 : 0));
      if (s === 'alt') return da < db ? -1 : (da > db ? 1 : 0);
      return da > db ? -1 : (da < db ? 1 : 0); /* neu (Standard) */
    });
    var shown = 0;
    arr.forEach(function (c) {
      var vis = star === 0 || parseFloat(c.dataset.rating) === star;
      c.hidden = !vis;
      if (vis) shown++;
      list.appendChild(c);
    });
    if (empty) empty.hidden = shown !== 0;
    if (status) status.textContent = shown + ' von ' + items.length + ' Bewertungen angezeigt';
  }

  if (sortSel) sortSel.addEventListener('change', apply);
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      chips.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      c.setAttribute('aria-pressed', 'true');
      star = parseInt(c.dataset.star, 10) || 0;
      apply();
    });
  });
  apply();
})();
